import loadingAttributePolyfill from 'loading-attribute-polyfill'
document.addEventListener('DOMContentLoaded', function () {
  var lazyImages = [].slice.call(document.querySelectorAll('img'))

  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target
          if (!lazyImage.classList.contains('loaded')) {
            lazyImage.classList.add('loaded')
            observer.unobserve(lazyImage)
          }
        }
      })
    })

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage)
    })
  }

  document.querySelectorAll('a[target="_blank"]').forEach((el) => {
    el.innerHTML =
      el.innerHTML +
      '<span class="visually-hidden"> (link opens in new tab/window)</span>'
  })
})

// open closed details elements for printing
window.addEventListener('beforeprint', () => {
  const allDetails = document.body.querySelectorAll('details')
  const allImages = document.body.querySelectorAll('img')
  for (let i = 0; i < allDetails.length; i++) {
    if (allDetails[i].open) {
      allDetails[i].dataset.open = '1'
    } else {
      allDetails[i].setAttribute('open', '')
    }
  }
  for (let i = 0; i < allImages.length; i++) {
    allImages[i].dataset.open = '1'
  }
})

// after printing close details elements not opened before
window.addEventListener('afterprint', () => {
  const allDetails = document.body.querySelectorAll('details')
  for (let i = 0; i < allDetails.length; i++) {
    if (allDetails[i].dataset.open) {
      allDetails[i].dataset.open = ''
    } else {
      allDetails[i].removeAttribute('open')
    }
  }
})

if (window.location.hash === '#help') {
  zE(function () {
    zE.activate()
  })

  function show() {
    zE.show()
    zE.activate()
  }
}

document.addEventListener('click', function (event) {
  if (!event.target.matches('.a.zendesk, button.zendesk, a[href="#help"]'))
    return
  event.preventDefault()
  zE(function () {
    zE.activate()
  })

  function show() {
    zE.show()
    zE.activate()
  }
})

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('noscript.loading-lazy').forEach((image) => {
      loadingAttributePolyfill.prepareElement(image)
      image.classList.add('loaded')
    })

    document.querySelectorAll('img').forEach((image) => {
      image.classList.add('loaded')
    })
  })
}
